import { useState, useEffect, useCallback } from "react";
import { IoAddOutline, IoCheckmark } from "react-icons/io5";
import Toaster from "../../../../components/common/Toaster";
import complianceService from "../../../../services/complianceService";

const CorFormsForm = ({ data, onSubmit, onClose }) => {
  const [taxTypes, setTaxTypes] = useState([]);

  const fetchTaxTypes = useCallback(
    async (mounted) => {
      try {
        const result = await complianceService.getTaxTypeFormsAsync();
        const items = result.map((item) => {
          const taxType = { ...item };
          taxType["is_selected"] =
            item.name === "Registration Fee" ? true : false;

          for (let i = 0; i < data.length; i++)
            if (data[i].id === item.id) taxType["is_selected"] = true;

          return taxType;
        });

        for (let j = 0; j < data.length; j++) {
          for (let i = items.length - 1; i >= 0; i--) {
            if (items[i].id === data[j].tax_type_id) {
              items.splice(i, 1);
            }
          }
        }

        if (mounted) setTaxTypes(items);
      } catch (ex) {
        Toaster.Error("Something went wrong.");
      }
    },
    [data]
  );

  const handleChange = (item) => {
    const items = [...taxTypes];
    const index = items.indexOf(item);

    items[index] = { ...items[index] };
    items[index].is_selected = !items[index].is_selected;
    setTaxTypes(items);
  };

  useEffect(() => {
    let mounted = true;

    fetchTaxTypes(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchTaxTypes]);

  const handleSubmit = () => {
    const selected = taxTypes.filter((i) => i.is_selected);
    onSubmit(selected);
    onClose(false);
  };

  return (
    <div className="p-8 space-y-1">
      {taxTypes.map((item, index) => {
        return (
          <div
            key={index}
            onClick={() => handleChange(item)}
            className="card p-3 cursor-pointer hover:border-blue-400"
          >
            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-400">{item.name}</p>
              {item.is_selected && <IoCheckmark className="text-green-500" />}
            </div>
          </div>
        );
      })}
      <div className="grid grid-cols-2 pt-2">
        <div className="col-span-2">
          <button
            className="button button-primary"
            onClick={() => handleSubmit()}
          >
            <IoAddOutline className="mr-2" /> Add to COR
          </button>
        </div>
      </div>
    </div>
  );
};

export default CorFormsForm;
